import { UserDto } from '@app/api/routes/auth/dtos'
import { isNullable } from '@app/utils/isNullable'
import { isNull } from '@app/utils/isNull'

export const getFullNameFromUser = (user?: UserDto | null): string | null => {
  if (isNullable(user)) return null

  const { lastName, firstName } = user

  if (isNull(lastName) && isNull(firstName)) return null

  if (isNull(lastName)) return firstName

  if (isNull(firstName)) return lastName

  return `${lastName} ${firstName}`
}
